import React from 'react';
import {Button} from "antd";

class PlusButton extends React.Component {

  render() {
    const {onClick, ...attributes} = this.props;

    return (
      <span style={{padding: '1rem'}}>
        <Button onClick={onClick} shape="circle" size="small" icon="plus" {...attributes}/>
      </span>
    )
  }
}

export default PlusButton;



// WEBPACK FOOTER //
// ./src/components/common/button/PlusButton.js